module.exports = __webpack_public_path__ + "assets/bloqhouse-involved.5a4331a3.svg";